<div class="assessment-container">
    <h2>HEENT</h2>

    <h2>Head</h2>
    <assessment-row title="Abnormal Shape" [historyMode]="true">
        <p>{{ data().headAbnormalShape }}</p>
    </assessment-row>

    @if (patient().isPediatric()) {
    <assessment-row title="Abnormal Fontanelles" [historyMode]="true">
        <p>{{ data().abnormalFontanelles ? "Yes" : "No" }}</p>
    </assessment-row>
    @if (data().abnormalFontanelles) {
    @if (data().fontanelleBulging) {
    <assessment-row title="Fontanelles Bulging" [historyMode]="true">
        <p>{{ data().fontanelleBulging }}</p>
    </assessment-row>
    }
    @if (data().fontanelleSunken) {
    <assessment-row title="Fontanelles Sunken" [historyMode]="true">
        <p>{{ data().fontanelleSunken }}</p>
    </assessment-row>
    }
    @if (data().fontanelleOther) {
    <assessment-row title="Other Fontanelle Abnormality" [historyMode]="true">
        <p>{{ data().fontanelleOther }}</p>
    </assessment-row>
    }
    }
    <assessment-row title="Sutures Overriding" [historyMode]="true">
        <p>{{ data().suturesOverriding ? "Yes" : "No" }}</p>
    </assessment-row>
    @if (data().suturesOverriding) {
    <assessment-row title="Sutures Overriding Details" [historyMode]="true">
        <p>{{ data().suturesOverridingDetails }}</p>
    </assessment-row>
    }
    }

    <assessment-row title="Lesions or Scars" [historyMode]="true">
        <p>{{ data().headLesionsOrScars }}</p>
    </assessment-row>
    <assessment-row title="Other" [historyMode]="true">
        <p>{{ data().headOther }}</p>
    </assessment-row>

    <h2>Eyes</h2>
    <assessment-row title="Pupillary Response" [historyMode]="true">
        <p>{{ data().pupillaryResponse }}</p>
    </assessment-row>
    <assessment-row title="Left Pupillary Dilation" [historyMode]="true">
        <p>{{ data().leftPupillaryDilation }}</p>
    </assessment-row>
    <assessment-row title="Right Pupillary Dilation" [historyMode]="true">
        <p>{{ data().rightPupillaryDilation }}</p>
    </assessment-row>
    <assessment-row title="Sclera Yellow" [historyMode]="true">
        <p>{{ isScleraYellow }}</p>
    </assessment-row>
    <assessment-row title="Conjunctiva Pale" [historyMode]="true">
        <p>{{ isConjunctivaPale }}</p>
    </assessment-row>
    <assessment-row title="Conjunctiva Red" [historyMode]="true">
        <p>{{ isConjunctivaRed }}</p>
    </assessment-row>
    <assessment-row title="Other" [historyMode]="true">
        <p>{{ data().eyesOther }}</p>
    </assessment-row>

    <h2>Ears</h2>
    <assessment-row title="Asymmetrical" [historyMode]="true">
        <p>{{ isAsymmetrical }}</p>
    </assessment-row>
    <assessment-row title="Hearing Impaired" [historyMode]="true">
        <p>{{ data().hearingImpaired }}</p>
    </assessment-row>
    @if (data().hearingImpaired != 'WNL') {
    <assessment-row title="Hearing Aid Left" [historyMode]="true">
        <p>{{ isHearingAidLeft }}</p>
    </assessment-row>
    <assessment-row title="Hearing Aid Right" [historyMode]="true">
        <p>{{ isHearingAidRight }}</p>
    </assessment-row>
    }
    <assessment-row title="Ears Discharge Present" [historyMode]="true">
        <p>{{ data().earsDischargePresent }}</p>
    </assessment-row>
    <assessment-row title="Other" [historyMode]="true">
        <p>{{ data().earsOther }}</p>
    </assessment-row>

    <h2>Nose</h2>
    <assessment-row title="Obstructed Nares" [historyMode]="true">
        <p>{{ data().obstructedNares }}</p>
    </assessment-row>
    <assessment-row title="Nose Discharge Present" [historyMode]="true">
        <p>{{ data().noseDischargePresent }}</p>
    </assessment-row>

    <h2>Neck</h2>
    <assessment-row title="Firm to Touch" [historyMode]="true">
        <p>{{ data().neckFirmToTouch }}</p>
    </assessment-row>
    <assessment-row title="Stiff Neck" [historyMode]="true">
        <p>{{ data().stiffNeck }}</p>
    </assessment-row>
    <assessment-row title="Enlarged Lymph Nodes" [historyMode]="true">
        <p>{{ data().enlargedLymphNodes }}</p>
    </assessment-row>
    <assessment-row title="Deviated Trachea" [historyMode]="true">
        <p>{{ data().deviatedTrachea }}</p>
    </assessment-row>

    <h2>Throat/Mouth</h2>
    <assessment-row title="Dry Mucus Membranes" [historyMode]="true">
        <p>{{ hasDryMucusMembranes }}</p>
    </assessment-row>
    <assessment-row title="Lesions Present" [historyMode]="true">
        <p>{{ data().throatLesionsPresent }}</p>
    </assessment-row>
    <assessment-row title="Enlarged Tonsils" [historyMode]="true">
        <p>{{ data().enlargedTonsils }}</p>
    </assessment-row>

    <assessment-row title="Other Findings" [historyMode]="true">
        <p>{{ data().otherFindings }}</p>
    </assessment-row>
</div>